export type TransportTabAvailability = {
  hasMultiYearTransactions: boolean;
  hasReshuffleTransactions: boolean;
};

type TransportTabDefinition = {
  path: string;
  label: string;
  isAvailable?: (availability: TransportTabAvailability) => boolean;
};

export const transportTabs = [
  { path: 'auctions', label: 'Auction Allocations' },
  { path: 'fcfs', label: 'FCFS Bookings' },
  { path: 'secondary', label: 'Secondary' },
  { path: 'conversions', label: 'Conversions' },
  {
    path: 'multi-year',
    label: 'Multi-Year Allocations',
    isAvailable: ({ hasMultiYearTransactions }) => hasMultiYearTransactions,
  },
  {
    path: 'reshuffling',
    label: 'Reshuffling',
    isAvailable: ({ hasReshuffleTransactions }) => hasReshuffleTransactions,
  },
  { path: 'surrender', label: 'Surrender' },
] as const satisfies readonly TransportTabDefinition[];

export type TransportTab = (typeof transportTabs)[number];

export type TransportTabPath = TransportTab['path'];

export const defaultTransportTabPath = 'auctions' satisfies TransportTabPath;

const transportTabByPath = Object.fromEntries(
  transportTabs.map((tab) => [tab.path, tab])
) as Record<TransportTabPath, TransportTab>;

export function getTransportTab(path: TransportTabPath): TransportTab {
  return transportTabByPath[path];
}

export function transportTabPathname(tab: TransportTabPath): string {
  return `/company-transactions/transport/${tab}`;
}

export function getAvailableTransportTabs(
  availability: TransportTabAvailability
): TransportTab[] {
  return transportTabs.filter((tab) =>
    'isAvailable' in tab ? tab.isAvailable(availability) : true
  );
}
